import BaseService from "./BaseService";

export default {
  index() {
    var url = "/recent-user-transaction-categories";

    return BaseService.get(url);
  },
};
